// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"bd1ad099","163":"19d13a24","184":"88a73028","335":"88a73028","581":"bb066542","945":"60935448"}[chunkId] + ".chunk.css";
};